import Header from '../../../components/Header'
import { Flex, Image, Text } from '@chakra-ui/react'
import { TableUsage } from '../Table'
import { FiltroPedidos } from '../FiltroPedidos'
import { listarDevolucoes } from '../../../services/api'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { EnviarListaParaFornecedor } from './EnviarListaParaFornecedor'

const loading_verde = '../../images/loading-verde.gif'

const DevolucaoTrocaCompra = () => {
  const [infos, setInfos] = useState([])
  const [loading, setLoading] = useState(false)
  const [dadosObservacoes, setDadosObservacoes] = useState('')
  const [open, setOpen] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty },
  } = useForm()

  async function submitForm(data) {
    setLoading(true)
    try {
      const dados = await listarDevolucoes.post('', data)
      setInfos(dados.data)
      setLoading(false)
    } catch (error) {
      console.log(Object.keys(error), error.message)
      setLoading(false)
    }
  }

  function handleOpenModal() {
    setOpen(!open)
  }

  const pegarObservacao = (observacao) => {
    setDadosObservacoes(observacao)
    setTimeout(() => {
      handleOpenModal()
      clearTimeout()
    }, 500)
  }

  useEffect(() => {
    submitForm({ pendente: 'S' })
  }, [])

  const counterNumPed = infos.filter((item, index, self) => self.findIndex((t) => t.pedido_troca === item.pedido_troca) === index).length

  return (
    <>
      <Flex flexDir="column">
        <Text paddingBlock="2rem" bg="#378BBF" textAlign="center" fontSize="1.2rem" color="white" fontWeight="bold">
          Devolução/Troca Compras
        </Text>
        <FiltroPedidos
          register={register}
          handleSubmit={handleSubmit}
          submitForm={submitForm}
          errors={errors}
          isSubmitting={isSubmitting}
          isDevTrocaCompra
        />
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontSize="1.2rem" fontWeight="bold" color="#606163" marginLeft={'1rem'} mb={'1rem'}>
            {counterNumPed} Pedidos
          </Text>
          <EnviarListaParaFornecedor />
        </Flex>
        {loading ? (
          <Loader img={loading_verde} />
        ) : (
          <TableUsage
            handleOpenModal={handleOpenModal}
            open={open}
            setOpen={setOpen}
            dadosObservacoes={dadosObservacoes}
            pegarObservacao={pegarObservacao}
            setLoading={setLoading}
            modalOpen={true}
            infos={infos}
            submitForm={submitForm}
            isCompra
          />
        )}
      </Flex>
    </>
  )
}

export default DevolucaoTrocaCompra
